import { render } from "./BulkParcelErrorsListItem.vue?vue&type=template&id=dd6c3dd8&scoped=true&ts=true"
import script from "./BulkParcelErrorsListItem.vue?vue&type=script&lang=ts"
export * from "./BulkParcelErrorsListItem.vue?vue&type=script&lang=ts"

import "./BulkParcelErrorsListItem.vue?vue&type=style&index=0&id=dd6c3dd8&scoped=true&lang=scss"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd6c3dd8"]])

export default __exports__